var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        disappear: _vm.animation_status === 2 || _vm.animation_status === 4,
      },
      attrs: { id: "contain" },
    },
    [
      _c("div", { staticClass: "layer" }),
      _c("div", { staticClass: "contain_main" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("这个箱子里可能有以下物品："),
        ]),
        _c(
          "div",
          { staticClass: "contain_list st_scroll" },
          _vm._l(_vm.tabulation, function (item, index) {
            return _c("div", { key: index, staticClass: "contain_item" }, [
              item.gold
                ? _c("div", { staticClass: "gold" }, [
                    _vm._m(0, true),
                    _c("p", { staticClass: "hide" }, [
                      _vm._v("★ " + _vm._s(item.text) + " ★"),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "normal" },
                    [
                      _c("div", { staticClass: "contain_core" }, [
                        _c("div", {
                          staticClass: "edge",
                          class: "rarity_" + item.groupId,
                        }),
                        _c("div", { staticClass: "pic" }, [
                          _c("img", { attrs: { src: item.itempic, alt: "" } }),
                        ]),
                      ]),
                      _c(
                        "Tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: item.itemname,
                            placement: "bottom",
                          },
                        },
                        [
                          _c("p", { staticClass: "hide" }, [
                            _vm._v(_vm._s(item.itemname)),
                          ]),
                        ]
                      ),
                      _c("span", [_vm._v(_vm._s(item.price))]),
                    ],
                    1
                  ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contain_core" }, [
      _c("div", { staticClass: "edge" }),
      _c("div", { staticClass: "pic" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/images/official/gold_icon.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }